import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters'
import mutations from './mutations'
import chat from './chat'
import {conn} from '@/utils/WebIM';

Vue.use(Vuex);


const store = new Vuex.Store({
    state: {
        userInfo: {}, //用户信息
        token: '', //用户token
        chatUsersList:[],
        meassageChatList:'',
        msgList:[],
        language: localStorage.getItem('changeLang') ? localStorage.getItem('changeLang') : 'zh-CN',

    },
    modules: {
      chat
    },
    getters: {
        // 用户信息
        userInfo(state) {
            if (state.userInfo) {
                return state.userInfo
            } else {
                return null
            }
        },
        // 用户Token
        token(state) {
            if (state.userInfo && state.userInfo.user_token) {
                return state.userInfo.user_token;
            } else {
                return null;
            }
        },
        isLogin(state) {
            if (state.userInfo == null) {
                return false;
            } else {
                return true;
            }
        },
        // 用户ID
        uid(state) {
            if (state.userInfo && state.userInfo.id) {
                return state.userInfo.id;
            } else {
                return 0;
            }
        },
    },
    mutations: {
         // 同步操作直接修改state里面的数据
    setLanguage: (state, data) => {
        state.language = data;
        localStorage.setItem('changeLang', data);
    },

        // 获取用户列表
        updateChatUsersList(state, list) {
          state.chatUsersList = list
        },
        // 聊天记录
        updateMeassageChatList(state, list) {
          state.meassageChatList = list
        },
        updateMsgList(state, payload){
        	console.log(state, payload, 'state, payload');
        	const { chatType, msg, bySelf, type, mid ,toID,time,chatId,id} = payload;
        	// payload的消息为漫游历史消息的话，进入判断筛选出已存在msgList当中的消息，此类消息不再添加进msgList。
        	if(payload.isHistory){
        		// 拿到该key已经存在的消息。
        		let nowKeyMsg = state.msgList[chatId];
        		// 开始筛选，如果payload.mid 不等于item.id则说明msgList中没有存储。
        		let newHistoryMsg = nowKeyMsg && nowKeyMsg.filter(item => {
        			return item.mid != payload.mid;
        		});
        		state.msgList[chatId] = newHistoryMsg;
        	}
        	// const { params } = Vue.$route;
        	// let status = 'unread';
        	// if(payload.chatType == 'contact'){
        	// 	if(params.id == payload.from){
        	// 		status = 'read';
        	// 	}
        	// }
        	// else if(payload.chatType == 'group'){
        	// 	if(params.id == payload.chatId){
        	// 		status = 'read';
        	// 	}
        	// }

        	if(!state.msgList[chatId]){
        		state.msgList[chatId] = [{
        			msg,
        			bySelf,
        			type: type || '',
        			mid: id,
        			// status: status,
        			...payload
        		}];
        	}
        	else{
                console.log(state.msgList[chatId],'kjhggff')
        		state.msgList[chatId].push({
        			msg,
        			bySelf,
        			type: type || '',
        			mid: id,
        			// status,
        			...payload
        		});
        		state.msgList[chatId] = state.msgList[chatId].sort((a, b) => {
        			return a.time - b.time;
        		});
        		// state.msgList[chatType][chatId] = _unique(state.msgList[chatType][chatId])
        	}

        	if(chatType === 'chatroom' && !bySelf){ // 聊天室消息去重处理
        		console.log(state.msgList[chatId], 'state.msgList[chatType][chatId]')
        		state.currentMsgs = state.msgList[chatId] // _.uniqBy(state.msgList[chatType][chatId], 'mid');
        	}
        	else{
        		state.currentMsgs = Object.assign({}, state.msgList[chatId]); // 这里params.id在路由跳转的时候会undefind，取chatId兼容
        	}
        	// state.msgList = Object.assign({}, state.msgList);
            // localStorage.setItem('msgList',JSON.stringify(state.msgList))

            console.log(state.msgList,'ldjjjjjsdddssdds')
        },
        // 更新用户信息
        updateUserInfo(state, userInfo) {
            state.userInfo = {...state.userInfo, ...userInfo };
            localStorage.setItem('USER_INFO', JSON.stringify(state.userInfo))

            const userName = 'hafa' + userInfo.id;
    		// const password = userInfo.password;

            console.log( WebIM,'opsospps')
    		let options = {
    			user: userName,
    			pwd: '123456',
    			appKey: WebIM.config.appkey
    		};
    		conn.open(options);
        },
        // 保存token
        saveToken(state, token) {
            state.token = token
            localStorage.setItem('USER_TOKEN', token);
        },
        // 退出登录
        logout(state) {
            state.userInfo = null;
            state.token = '';
            localStorage.removeItem('USER_INFO')
            localStorage.removeItem('USER_TOKEN')
            localStorage.removeItem('userNumber')
            localStorage.removeItem('AUTH_STATUS')
            localStorage.removeItem('is_bind')
            localStorage.removeItem('KEFU_INFO')
        }
    },
    actions: {

    }
})


// 创建 store 实例
export default store;



// WEBPACK FOOTER //
// ./src/vuex/index.js